import parseImgix from '@utils/parseImgix';
import React from 'react';
import Imgix from 'react-imgix';

interface ImgixParams {
  [key: string]: any;
}

interface ImgixWrapperProps {
  src: string;
  alt?: string;
  height?: number;
  width?: number;
  sizes?: string;
  imgixParams?: ImgixParams;
  className?: string;
}

const ImgixWrapper: React.FC<ImgixWrapperProps> = ({
  src,
  alt = '',
  height,
  width,
  sizes = '',
  imgixParams = {},
  className = '',
}) => {
  if (!src) return null;

  const imgixSrc = parseImgix(src);

  if (!imgixSrc) {
    console.warn('Could not parse to Imgix:', { src, imgixSrc });
    return null;
  }

  return (
    <Imgix
      src={imgixSrc}
      height={height}
      width={width}
      imgixParams={{
        fit: 'crop',
        crop: 'entropy',
        ...imgixParams,
      }}
      className={`lazyload imgix-image ${className}`}
      attributeConfig={{
        src: 'data-src',
        srcSet: 'data-srcset',
        sizes: 'data-sizes',
      }}
      htmlAttributes={{
        alt,
      }}
      sizes={sizes}
    />
  );
};

export default ImgixWrapper;
